import { Routes, RouterModule } from '@angular/router';

const navigationRoutes: Routes = [
];

export const navigationRouting = RouterModule.forChild(navigationRoutes);
